{
  "codexEntityForm": {
    "character": "Rollfigur",
    "place": "Plats",
    "faction": "Fraktion",
    "object": "Föremål",
    "concept": "Begrepp",
    "editName": "Redigera {{name}}",
    "newCodexEntry": "Ny Kodex-post",
    "theWorldHasChangedTheDraft": "Världen har ändrats. Utkastet bevaras; läs in posten igen innan du sparar.",
    "portraitChooseAnImage": "Porträtt: välj en bild",
    "change": "Ändra",
    "addPortrait": "Lägg till porträtt",
    "portraitImage": "Porträttbild",
    "entryName": "Postens namn",
    "name": "Namn",
    "entryType": "Typ av post",
    "customCategory": "Egen kategori",
    "categoryEGDeityShipSpell": "Kategori, t.ex. Gudom, Skepp, Besvärjelse",
    "aliases": "Alias",
    "entryAliases": "Postens alias",
    "otherNamesOneAtATime": "Andra namn, ett i taget…",
    "tags": "Taggar",
    "entryTags": "Postens taggar",
    "themesRolesArcs": "Teman, roller, bågar…",
    "collection": "Samling",
    "entryCollection": "Postens samling",
    "noCustomCollection": "Ingen egen samling",
    "folder": "Mapp",
    "entryFolder": "Postens mapp",
    "unfiled": "Ej i någon mapp",
    "notes": "Anteckningar",
    "entryNotes": "Postens anteckningar",
    "whoTheyAreWhatTheyWant": "Vem de är, vad de vill, vad läsaren inte får få veta för tidigt…",
    "entryFields": "Postens fält",
    "fields": "Fält",
    "fieldTemplate": "Fältmall",
    "template": "Mall…",
    "schemaOf": "Schema för",
    "addMissingFields": "Lägg till saknade fält",
    "addField": "Lägg till fält",
    "noCustomFieldYetFieldsGive": "Inga egna fält ännu. Fält ger en post strukturerade fakta – ålder, lojalitet, en hemlighet – som Kontroller kan resonera om.",
    "sharedFieldNamesTypesAndOptions": "Namn, typer och alternativ för delade fält hanteras i samlingens inställningar. Värdena hör till den här sidan.",
    "fieldNameN": "Fältnamn {{n}}",
    "fieldName": "Fältnamn",
    "fieldTypeN": "Fälttyp {{n}}",
    "unknown": "Okänt",
    "fieldValueN": "Fältvärde {{n}}",
    "select": "Välj…",
    "yes": "Ja",
    "no": "Nej",
    "value": "Värde",
    "chooseAnEntry": "Välj en post…",
    "eGSpringOfYear12": "t.ex. Våren år 12, eller dagen för belägringen",
    "below": "Nedan",
    "unknownValueN": "Okänt värde {{n}}",
    "required": "Obligatoriskt",
    "sharedField": "Delat fält",
    "remove": "Ta bort",
    "confirmRemoval": "Bekräfta borttagning",
    "paragraph": "Stycke",
    "aFewLines": "Några rader…",
    "discardTheDraft": "Förkasta utkastet?",
    "confirmReload": "Bekräfta omläsning",
    "keepEditing": "Fortsätt redigera",
    "reloadEntry": "Läs in posten igen",
    "cancel": "Avbryt",
    "chooseAnImageFileForThe": "Välj en bildfil till porträttet.",
    "thePortraitMustBeUnder8": "Porträttet måste vara under 8 MiB.",
    "saveEntry": "Spara post",
    "searchEntries": "Sök poster …"
  },
  "codexEntryDialog": {
    "newCodexEntry": "Ny Kodex-post",
    "savedToWorldCodexTheManuscript": "Sparad i Värld › Kodex; manuset nämner den där du skrev.",
    "createAndMention": "Skapa och nämn"
  },
  "continuityPanel": {
    "relationsOverTime": "Relationer över tid",
    "checkingRelations": "Kontrollerar relationer…",
    "cancel": "Avbryt",
    "theProjectHasChangedRunThe": "Manuset eller världen har ändrats sedan den här körningen. Kör kontrollerna igen för att uppdatera relationerna.",
    "anAnalysisLimitWasReachedThe": "En analysgräns nåddes. Resultatet är ofullständigt.",
    "ruleApplied": "Regel: ”{{label}}”, {{rule}}.",
    "oneSourcePerTarget": "en källa för varje mål",
    "oneTargetPerSource": "ett mål för varje källa",
    "interval": "från {{start}} till {{end}}",
    "openScene": "Öppna {{scene}}",
    "findingReferenceMissing": "Pekar på en post som inte längre finns.",
    "findingConfirmedWithoutEvidence": "Bekräftad utan ett citat ur texten, så dess källa kan inte kontrolleras.",
    "findingEvidenceMissing": "Ett citat den bygger på har försvunnit.",
    "findingEvidenceNotCurrent": "Ett citat den bygger på är inte bekräftat eller stämmer inte längre med texten.",
    "findingExclusiveNotEvaluable": "Kan inte kontrolleras mot regeln: den kräver en riktning, båda ändarna och ett fullständigt tidsintervall.",
    "findingExclusiveOverlap": "Två av dessa gäller samtidigt, vilket regeln inte tillåter.",
    "findingOther": "Något att kontrollera i den här relationen.",
    "theProjectExceedsTheLimitOf": "Projektet överskrider gränsen för den här analysen. Inga data ändrades.",
    "theAnalysisExceededItsExecutionLimit": "Analysen överskred sin körningsgräns. Inga data ändrades.",
    "analysisCancelled": "Analysen avbröts.",
    "checksNotCompletedTheTextAnd": "Kontrollerna slutfördes inte. Texten och kanon ändrades inte."
  },
  "eventTimelinePanel": {
    "eventHistory": "Händelsehistorik",
    "timeline": "Tidslinje",
    "newEvent": "Ny händelse",
    "searchEvents": "Sök händelser",
    "searchEvents2": "Sök händelser…",
    "timelineOrder": "Tidslinjens ordning",
    "storyTime": "Berättelsens tid",
    "readingOrder": "Läsordning",
    "dateStatus": "Datumstatus",
    "allDates": "Alla datum",
    "resolvedDates": "Fastställda datum",
    "unresolvedDates": "Ofastställda datum",
    "filterEventsByScene": "Filtrera händelser efter scen",
    "allScenes": "Alla scener",
    "scenes": "Scener",
    "editEvent": "Redigera händelse",
    "closeEventEditor": "Stäng händelseredigeraren",
    "theWorldHasChangedReloadThe": "Världen har ändrats. Läs in händelsen igen innan du sparar; utkastets fält bevaras.",
    "eventTitle": "Händelsens titel",
    "whatHappens": "Vad som händer",
    "scene": "Scen",
    "eventScene": "Händelsens scen",
    "notLinked": "Inte länkad",
    "removedSceneSceneid": "Borttagen scen – {{sceneId}}",
    "dateType": "Datumtyp",
    "eventDateType": "Händelsens datumtyp",
    "unknown": "Okänd",
    "definedInterval": "Definierat intervall",
    "relativeToAnEvent": "Relativt en händelse",
    "start": "Start",
    "eventStart": "Händelsens start",
    "endExclusive": "Slut (exklusive)",
    "eventEnd": "Händelsens slut",
    "referenceEvent": "Referenshändelse",
    "select": "Välj…",
    "referenceToVerifyAnchoreventid": "Referens att verifiera – {{anchorEventId}}",
    "events": "Händelser",
    "offsetInTicks": "Förskjutning i tick",
    "eventOffset": "Händelsens förskjutning",
    "saveEvent": "Spara händelse",
    "closeReload": "Stäng / läs in igen…",
    "discardTheDraftChanges": "Förkasta ändringarna i utkastet?",
    "discardDraft": "Förkasta utkast",
    "reloadEvent": "Läs in händelsen igen",
    "keepEditing": "Fortsätt redigera",
    "noEventMatchesTheseFiltersEvents": "Ingen händelse matchar de här filtren. Händelser är det Kontrollerna resonerar om: när något hände och i vilken scen läsaren får veta det.",
    "tickStart": "Tick {{start}}",
    "openScene": "Öppna scen",
    "editTitle": "Redigera {{title}}",
    "removeTitle": "Ta bort {{title}}",
    "confirmEventRemoval": "Bekräfta borttagning av händelsen",
    "cancel": "Avbryt",
    "theWorldHasChangedCancelAnd": "Världen har ändrats: avbryt och öppna bekräftelsen igen.",
    "resolvedDate": "Fastställt datum",
    "unknownDate": "Okänt datum",
    "missingReference": "Saknad referens",
    "timeCycle": "Tidscykel",
    "dateOutOfRange": "Datum utanför intervallet",
    "eventsFoundOfTotal_one": "{{count}} händelse hittades · {{total}} totalt",
    "eventsFoundOfTotal_other": "{{count}} händelser hittades · {{total}} totalt",
    "removeThisEventReferences_one": "Ta bort den här händelsen? {{count}} direkt referens behöver granskas.",
    "removeThisEventReferences_other": "Ta bort den här händelsen? {{count}} direkta referenser behöver granskas.",
    "showMoreEvents_one": "Visa {{count}} händelse till",
    "showMoreEvents_other": "Visa {{count}} händelser till"
  },
  "fieldEditor": {
    "choose": "Välj…",
    "labelSearch": "Sök {{label}}",
    "search": "Sök…",
    "labelOptions": "Alternativ för {{label}}",
    "noMatch": "Ingen träff.",
    "optionsOnePerLine": "Alternativ, ett per rad",
    "fieldOptionsIndex": "Fältalternativ {{index}}",
    "addOptionIndex": "Lägg till alternativ {{index}}",
    "newOption": "Nytt alternativ",
    "addOption": "Lägg till alternativ",
    "fieldValueIndex": "Fältvärde {{index}}",
    "chooseOptions": "Välj alternativ…",
    "chooseEntries": "Välj poster…",
    "unsupportedMultiValueEditor": "Redigerare för flera värden stöds inte"
  },
  "graphExplorer": {
    "relationGraph": "Relationsgraf",
    "entry": "Post",
    "filterGraphByEntry": "Filtrera grafen efter post",
    "all": "Alla",
    "status": "Status",
    "graphRelationStatus": "Status för grafens relationer",
    "proposedAndConfirmed": "Föreslagna och bekräftade",
    "confirmed": "Bekräftade",
    "proposed": "Föreslagna",
    "relation": "Relation",
    "searchRelationInTheGraph": "Sök relation i grafen",
    "filterAtStoryTime": "Filtrera efter berättelsens tid",
    "tick": "Tick",
    "graphTick": "Grafens tick",
    "includeUnknownTime": "Ta med okänd tid",
    "enterANumericTickOrTurn": "Ange ett numeriskt tick eller stäng av tidsfiltret.",
    "navigableRelationGraph": "Navigerbar relationsgraf",
    "selectName": "Välj {{name}}",
    "entryCount_one": "{{count}} post",
    "entryCount_other": "{{count}} poster",
    "relationCount_one": "{{count}} relation",
    "relationCount_other": "{{count}} relationer",
    "hiddenBeyondViewLimit": "{{entries}} och {{relations}} utanför visningsgränsen.",
    "relationsWithMissingEntries_one": "{{count}} relation med saknade poster.",
    "relationsWithMissingEntries_other": "{{count}} relationer med saknade poster.",
    "unknownDurationIncluded_one": "{{count}} relation med okänd varaktighet ingår i filtret.",
    "unknownDurationIncluded_other": "{{count}} relationer med okänd varaktighet ingår i filtret.",
    "unknownDurationExcluded_one": "{{count}} relation med okänd varaktighet utesluts från filtret.",
    "unknownDurationExcluded_other": "{{count}} relationer med okänd varaktighet utesluts från filtret."
  },
  "relationshipPanel": {
    "select": "Välj…",
    "removedReference": "Borttagen referens:",
    "projectRelations": "Projektets relationer",
    "relationsOf": "Relationer för",
    "filterRelationsByEntry": "Filtrera relationer efter post",
    "allEntries": "Alla poster",
    "searchEntries": "Sök poster…",
    "searchRelations": "Sök relationer",
    "relationOrEntry": "Relation eller post",
    "newRelation": "Ny relation",
    "editRelation": "Redigera relation",
    "relationsLinkTwoEntries": "Relationer länkar två poster",
    "addTwoEntriesInTheCodex": "Lägg till minst två poster i Kodex och skriv sedan orden som binder dem samman, som ”är mentor till”.",
    "theWorldHasChangedTheFields": "Världen ändrades medan detta var öppet. Dina fält bevaras; läs in igen för att spara mot de nya uppgifterna.",
    "reload": "Läs in igen",
    "anEntry": "En post",
    "anotherEntry": "En annan post",
    "relationSource": "Relationens källa",
    "relationType": "Relationens typ",
    "isTheMentorOf": "är mentor till",
    "relationTarget": "Relationens mål",
    "direction": "Riktning",
    "relationDirection": "Relationens riktning",
    "oneWay": "Enkelriktad",
    "bothWays": "Dubbelriktad",
    "when": "När",
    "relationTime": "Relationens tid",
    "notSet": "Inte angiven",
    "betweenTwoMoments": "Mellan två tidpunkter",
    "fromAnEvent": "Från en händelse",
    "from": "Från",
    "to": "till",
    "relationStart": "Relationens start",
    "relationEnd": "Relationens slut",
    "momentsHint": "Tidpunkter på världens tidslinje; slutet ingår inte.",
    "event": "Händelse",
    "relationEvent": "Relationens händelse",
    "offset": "Förskjutning",
    "relationOffset": "Relationens förskjutning",
    "offsetHint": "Tidpunkter efter händelsen; negativt för före.",
    "status": "Status",
    "relationStatus": "Relationens status",
    "proposed": "Föreslagen",
    "confirmed": "Bekräftad",
    "rejected": "Avvisad",
    "superseded": "Ersatt",
    "confirmedRelationsCountAsCanonIn": "Bekräftade relationer räknas som kanon i Kontroller.",
    "notes": "Anteckningar",
    "relationNotes": "Relationens anteckningar",
    "howTheStoryShowsItAnd": "Hur berättelsen visar den och vad som förblir tvetydigt.",
    "quotes": "Citat",
    "linkQuotes": "Länka citat ur texten",
    "quotesLinked": "Citat: {{count}}",
    "searchQuotations": "Sök citat",
    "excerptOrNote": "Utdrag eller anteckning",
    "removedQuotation": "Borttaget citat:",
    "noQuotationYetAnnotateAPassage": "Inga citat ännu. Kommentera ett stycke i manuset för att citera det här.",
    "upTo100QuotationsShownUse": "Upp till 100 citat visas. Använd sökningen för att avgränsa listan.",
    "saveRelation": "Spara relation",
    "cancel": "Avbryt",
    "aDeletedEntry": "en borttagen post",
    "aDeletedEvent": "en borttagen händelse",
    "timeBetween": "Från {{start}} till {{end}}",
    "timeAtEvent": "Vid {{event}}",
    "timeAfterEvent": "{{event}} + {{offset}}",
    "timeBeforeEvent": "{{event}} − {{offset}}",
    "noRelationsYet": "Ingen relation ännu.",
    "noRelationMatches": "Ingen relation matchar.",
    "edit": "Redigera",
    "editCaption": "Redigera {{caption}}",
    "remove": "Ta bort",
    "removeCaption": "Ta bort {{caption}}",
    "removeThisRelationTheChangeStays": "Ta bort den här relationen? Ändringen finns kvar i historiken.",
    "confirmRemoval": "Ta bort",
    "shownOfTotal": "100 av {{total}} relationer visas. Avgränsa sökningen för att se de andra.",
    "theWorldHasChangedReloadThe": "Världen har ändrats. Läs in relationen igen innan du sparar.",
    "theRelationWasChangedOrRemoved": "Relationen ändrades eller togs bort. Läs in uppgifterna igen.",
    "explicitlyConfirmTheRelationBeforeSaving": "Välj Bekräftad igen för att göra den här relationen till kanon.",
    "selectTwoEntriesThatExistIn": "Välj två poster som finns i Kodex.",
    "fillInTheTimeValuesOr": "Fyll i tidpunkterna eller välj Inte angiven.",
    "enterAValidIntervalTheEnd": "Slutet måste komma efter starten.",
    "selectAnExistingEventAsThe": "Välj en händelse som fortfarande finns.",
    "theSelectedQuotationIsNoLonger": "Ett valt citat finns inte längre.",
    "checkTheRelationTextAndThe": "Kontrollera relationens ord och anteckningarna.",
    "theChangeWasNotSavedReload": "Ändringen sparades inte. Läs in uppgifterna igen och försök på nytt."
  },
  "useWorldReplication": {
    "signInToTheLinkedAccount": "Logga in på det kopplade kontot och kontrollera din åtkomst till projektet. Dina lokala ändringar bevaras.",
    "syncTheManuscriptWithThisServer": "Synkronisera manuset med den här servern innan du länkar dess Värld.",
    "theWorldChangedAfterTheComparison": "Världen ändrades efter jämförelsen. Granska de aktuella kopiorna igen.",
    "aConfirmationOrRestoredRecordNeeds": "En bekräftelse eller en återställd post måste granskas uttryckligen innan den kan synkroniseras.",
    "anAttachmentOrRemoteCopyFailed": "En bilaga eller fjärrkopia klarade inte verifieringen. Din lokala Värld bevaras.",
    "theseChangesExceedASyncLimit": "De här ändringarna överskrider en synkroniseringsgräns eller måste tillämpas tillsammans. Din lokala Värld och väntande ändringar bevaras.",
    "syncPausedYourLocalChangesAre": "Synkroniseringen är pausad. Dina lokala ändringar bevaras.",
    "newMapNeedsPlan": "Nya kartor ingår i Ink och Press. Kartan finns kvar på den här enheten och Världen väntar: ta bort den nya kartan eller välj en plan för att synkronisera igen.",
    "worldSyncCouldNotFinishCheck": "Världens synkronisering kunde inte slutföras. Kontrollera anslutningen och försök igen. Dina lokala ändringar bevaras."
  },
  "vaultFolders": {
    "folderName": "Mappen {{name}}",
    "editFolder": "Redigera mapp",
    "newSubfolder": "Ny undermapp",
    "moveContentsBeforeRemoving": "Flytta innehållet innan du tar bort den",
    "removeFolder": "Ta bort mapp",
    "folderActionsName": "Åtgärder för mappen {{name}}",
    "chooseThisFolderWhenEditingA": "Välj den här mappen när du redigerar en sida.",
    "projectFolders": "Projektmappar",
    "folders": "Mappar",
    "newFolder": "Ny mapp",
    "groupPagesFromAnyCollection": "Gruppera sidor från vilken samling som helst.",
    "foldersOrganizePagesWithoutChangingTheir": "Mappar organiserar sidor utan att ändra deras samling eller innehåll.",
    "cancel": "Avbryt",
    "saveFolder": "Spara mapp",
    "name": "Namn",
    "folderName2": "Mappens namn",
    "inside": "Inuti",
    "parentFolder": "Överordnad mapp",
    "projectRoot": "Projektets rot",
    "removeEmptyFolder": "Ta bort den tomma mappen?",
    "removeNameFromTheProject": "Ta bort ”{{name}}” från projektet?"
  },
  "vaultTable": {
    "unavailableEntry": "Otillgänglig post",
    "vaultTable": "Valvtabell",
    "pages": "Sidor",
    "searchVaultTable": "Sök i valvtabellen",
    "searchPages": "Sök sidor…",
    "tableCollection": "Tabellens samling",
    "allCollections": "Alla samlingar",
    "noCustomCollection": "Ingen egen samling",
    "tableFolder": "Tabellens mapp",
    "allFolders": "Alla mappar",
    "unfiled": "Ej i någon mapp",
    "scrollableVaultTable": "Valvtabell med rullning",
    "name": "Namn",
    "collection": "Samling",
    "folder": "Mapp",
    "noPagesMatchTheseFilters": "Inga sidor matchar de här filtren.",
    "none": "Ingen",
    "yes": "Ja",
    "no": "Nej",
    "pagesShown_one": "{{shown}} av {{count}} sida",
    "pagesShown_other": "{{shown}} av {{count}} sidor"
  },
  "vaultTree": {
    "blue": "Blå",
    "emerald": "Smaragd",
    "gold": "Guld",
    "violet": "Violett",
    "rose": "Ros",
    "amber": "Bärnsten",
    "teal": "Blågrön",
    "slate": "Skiffer",
    "crimson": "Karmosin",
    "bark": "Bark",
    "forest": "Skog",
    "navy": "Marinblå",
    "orchid": "Orkidé",
    "saffron": "Saffran",
    "ink": "Bläck",
    "ember": "Glöd",
    "concept": "Begrepp",
    "character": "Rollfigur",
    "place": "Plats",
    "faction": "Fraktion",
    "object": "Föremål",
    "vault": "Valv",
    "newCollection": "Ny samling",
    "vaultView": "Valvets vy",
    "pages": "Sidor",
    "table": "Tabell",
    "pagesMarkedUnassignedKeepTheirPrevious": "Sidor markerade som ej tilldelade behåller sina tidigare fält. Redigera en sida för att välja dess samling.",
    "filterPages": "Filtrera sidor",
    "filterPages2": "Filtrera sidor…",
    "worldVault": "Världens valv",
    "removeCollectionName": "Ta bort samlingen {{name}}",
    "collectionSettingsForName": "Inställningar för samlingen {{name}}",
    "iconAndColour": "Ikon och färg",
    "newPageInName": "Ny sida i {{name}}",
    "noPageYetAddTheFirst": "Ingen sida ännu – lägg till den första med +.",
    "nothingHereYet": "Inget här ännu.",
    "removeEmptyCollection": "Ta bort den tomma samlingen?",
    "removeNameAndItsSchema": "Ta bort ”{{name}}” och dess schema?",
    "removeCollection": "Ta bort samling",
    "text": "Text",
    "theSvgMustBeUnder16": "SVG-filen måste vara under 16 KiB.",
    "thisFileIsNotAUsable": "Den här filen är ingen användbar SVG (skript och externa referenser tas bort; roten måste vara <svg>).",
    "collectionName": "Samling: {{name}}",
    "sharedFieldsApplyToEveryPage": "Delade fält gäller alla sidor i den här samlingen. Varje sida kan också ha egna fält.",
    "cancel": "Avbryt",
    "saving": "Sparar…",
    "saveCollection": "Spara samling",
    "createCollection": "Skapa samling",
    "identity": "Identitet",
    "nameAndIconAsTheTree": "Namn och ikon, så som trädet och sidorna kommer att visa dem.",
    "name": "Namn",
    "collectionName2": "Samlingens namn",
    "magic": "Magi",
    "aCollectionWithThisNameAlready": "Det finns redan en samling med det här namnet.",
    "icon": "Ikon",
    "iconSource": "Ikonens källa",
    "lucide181": "Lucide (181)",
    "yourSvg": "Din SVG",
    "collectionIcon": "Samlingens ikon",
    "searchLucideIcons": "Sök Lucide-ikoner",
    "searchIconsCastleSwordMoon": "Sök ikoner – slott, svärd, måne…",
    "loadingIcons": "Läser in ikoner…",
    "lucideIcon": "Lucide-ikon",
    "noIconMatches": "Ingen ikon matchar.",
    "chooseAnSvgFile": "Välj en SVG-fil",
    "customSvgIcon": "Egen SVG-ikon",
    "upTo16KibScriptsLinks": "Upp till 16 KiB. Skript, länkar och externa referenser tas bort; använd currentColor i filen så att samlingens färg gäller.",
    "colour": "Färg",
    "aPresetOneYouUsedRecently": "Ett förval, en du använt nyligen eller din egen från färghjulet.",
    "collectionColour": "Samlingens färg",
    "recent": "Senaste",
    "useHex": "Använd {{hex}}",
    "kindOfPage": "Typ av sida",
    "everyPageIsACodexEntry": "Varje sida är en Kodex-post av en viss typ; typen avgör hur Kontroller, @-omnämnanden och grafen behandlar den, och behåller sin färg överallt.",
    "collectionBaseKind": "Samlingens grundtyp",
    "magicOrShipsConceptDeitiesOr": "Magi eller Skepp → Begrepp · Gudar eller Hus → Rollfigur eller Fraktion · en samling städer → Plats.",
    "sharedFields": "Delade fält",
    "thePropertiesOfTheCollectionValues": "Samlingens egenskaper – värdena finns på varje sida, och en sida kan ändå lägga till egna.",
    "collectionTemplate": "Samlingens mall",
    "template": "Mall…",
    "addField": "Lägg till fält",
    "exampleMagicLevelNumberRarityChoice": "Exempel: Magi → Nivå (tal) · Sällsynthet (val: vanlig, sällsynt, legendarisk) · Erhållen (berättelsedatum) · Lärd av (postlänk).",
    "collectionFieldNameValue": "Samlingsfältets namn {{value}}",
    "fieldName": "Fältnamn",
    "collectionFieldTypeValue": "Samlingsfältets typ {{value}}",
    "collectionFieldOptionsValue": "Samlingsfältets alternativ {{value}}",
    "optionsOnePerLine": "Alternativ, ett per rad",
    "required": "Obligatoriskt",
    "requiredCollectionFieldValue": "Obligatoriskt samlingsfält {{value}}",
    "removeCollectionFieldValue": "Ta bort samlingsfältet {{value}}",
    "yesNo": "Ja / Nej",
    "multipleChoice": "Flerval",
    "storyDate": "Berättelsedatum",
    "entryLink": "Postlänk",
    "multipleEntryLinks": "Flera postlänkar",
    "fieldParagraph": "Stycke",
    "fieldNumber": "Tal",
    "fieldChoice": "Val"
  },
  "worldCloudPanel": {
    "worldCloudVersions": "Världens molnversioner",
    "includesCodexPagesCollectionsFoldersFacts": "Omfattar Kodex-sidor, samlingar, mappar, fakta, relationer och bilagor. Publicera eller ladda ned en version uttryckligen. Manuset använder synkronisering per scen.",
    "compareVersions": "Jämför versioner",
    "recoverPreviousWorld": "Återskapa föregående Värld…",
    "deviceRevision": "Enhetens revision",
    "accountVersionRemoteversion": "Kontoversion {{remoteVersion}}",
    "firstAccountVersion": "Första kontoversionen",
    "uploadDeviceVersion": "Ladda upp enhetens version…",
    "useAccountVersion": "Använd kontoversionen…",
    "confirmTransfer": "Bekräfta överföringen",
    "replaceWorldOnThisDeviceWith": "Ersätta Världen på den här enheten med den här versionen? En kopia av den nuvarande Världen och bilagorna sparas först. Manustexten förblir oförändrad.",
    "saveThisCopyToYourAccount": "Spara den här kopian på ditt konto? Tidigare kontoversioner behålls.",
    "restoreWorldFromBeforeTheLast": "Återställa Världen till läget före den senaste överföringen? Senare redigeringar hindrar den här återställningen.",
    "confirm": "Bekräfta",
    "cancel": "Avbryt",
    "transferring": "Överför…",
    "codexPages": "Kodex-sidor",
    "updateStoryideBeforePublishingChangesTo": "Uppdatera Musael innan du publicerar ändringar i det här Valvet.",
    "theAccountVersionChangedCompareAgain": "Kontoversionen har ändrats. Jämför igen innan du tillämpar.",
    "worldChangedOnThisDeviceCompare": "Världen har ändrats på den här enheten. Jämför igen innan du tillämpar.",
    "accountVersionStorageIsFullPrevious": "Lagringsutrymmet för kontoversioner är fullt. Tidigare kopior behålls.",
    "anAttachmentFailedItsIntegrityCheck": "En bilaga klarade inte integritetskontrollen. Ingen lokal kopia ersattes.",
    "theAccountCopyFailedItsIntegrity": "Kontokopian klarade inte integritetskontrollen.",
    "noRecoveryCopyIsAvailableFor": "Ingen återställningskopia finns för den här överföringen.",
    "anIdentifierIsAlreadyUsedIn": "Ett ID används redan i ett annat projekt.",
    "openOrSyncTheManuscriptWith": "Öppna eller synkronisera först manuset med ditt konto.",
    "yourAccountDoesNotHaveThe": "Ditt konto har inte den behörighet som krävs.",
    "signInAgainThisSessionWas": "Logga in igen. Den här sessionen har återkallats.",
    "transferCancelled": "Överföringen avbröts.",
    "transferFailedCheckYourConnectionAnd": "Överföringen misslyckades. Kontrollera din anslutning och jämför igen.",
    "couldNotReadTheRecoveryCopy": "Det gick inte att läsa återställningskopian.",
    "mondoPrecedenteRipristinato": "Föregående Värld har återställts.",
    "accountVersionVersionSaved": "Kontoversion {{version}} sparad.",
    "versionVersionAppliedToWorldOn": "Version {{version}} tillämpad på Världen på den här enheten.",
    "cancellationRequested": "Avbrytande begärt.",
    "labelFacts": "Fakta",
    "labelEvents": "Händelser",
    "labelKnowledge": "Kunskap",
    "labelAnnotations": "Anteckningar",
    "labelRelationships": "Relationer",
    "labelAttachments": "Bilagor",
    "labelCollections": "Samlingar",
    "labelFolders": "Mappar",
    "changedCount_one": "{{count}} ändrad",
    "changedCount_other": "{{count}} ändrade"
  },
  "worldMaps": {
    "character": "Rollfigur",
    "place": "Plats",
    "object": "Föremål",
    "faction": "Fraktion",
    "concept": "Begrepp",
    "pinOf": "Nål: {{name}}",
    "pinMissing": "Nål för en saknad post",
    "missingEntry": "Saknad post",
    "zoom": "Zoom",
    "zoomIn": "Zooma in",
    "zoomOut": "Zooma ut",
    "fitToView": "Anpassa till vyn",
    "newMap": "Ny karta",
    "newMapDescription": "En bild av en plats, för nålar på människorna, platserna och sakerna som finns där.",
    "cancel": "Avbryt",
    "saving": "Sparar…",
    "createMap": "Skapa karta",
    "mapOf": "Karta över",
    "aNewPlace": "En ny plats",
    "placeName": "Platsens namn",
    "placeNamePlaceholder": "Saltkusten",
    "picture": "Bild",
    "choosePicture": "Välj en PNG, JPEG, WebP eller GIF",
    "pictureHint": "Upp till 16 MB. Den blir en av postens bilagor.",
    "maps": "Kartor",
    "mapsLead": "Fäst poster på bilderna av dina platser. En fäst plats med en egen karta öppnar den.",
    "noMapsYet": "Inga kartor ännu",
    "noMapsText": "Ge en plats en bild och fäst sedan de poster som hör hemma där.",
    "addTheFirstMap": "Lägg till den första kartan",
    "onePin": "1 nål",
    "pins": "{{count}} nålar",
    "inPlace": "på {{place}}",
    "chooseAnEntryOrName": "Välj en post eller skriv ett namn för nålen.",
    "mapTrail": "Kartor ovanför den här",
    "doneAdding": "Klart",
    "addPin": "Lägg till nål",
    "labels": "Etiketter",
    "replacePicture": "Byt bild",
    "removeMap": "Ta bort kartan",
    "hintClick": "Klicka på kartan där nålen ska sitta.",
    "hintChoose": "Välj vad nålen pekar på, till höger.",
    "pictureMissing": "Kartans bild finns inte på den här enheten ännu.",
    "pinDetails": "Nålens uppgifter",
    "newPin": "Ny nål",
    "entry": "Post",
    "chooseAnEntry": "Välj en post",
    "noEntryLabelOnly": "Ingen post, bara en etikett",
    "labelOnTheMap": "Etikett på kartan",
    "labelDefault": "Postens namn",
    "labelRequired": "Behövs utan post",
    "placePin": "Placera nål",
    "label": "Etikett",
    "openEntry": "Öppna posten",
    "openItsMap": "Öppna dess karta",
    "position": "{{x}} % från vänster, {{y}} % uppifrån",
    "removePin": "Ta bort nålen",
    "noPinsYet": "Inga nålar ännu. Använd Lägg till nål och klicka sedan på kartan.",
    "shownOn": "Visas på",
    "openEntryOf": "Öppna {{name}}",
    "removeMapTitle": "Ta bort kartan över {{name}}?",
    "removeMapMessage": "Nålarna försvinner med den. Bilden finns kvar bland postens bilagor."
  },
  "worldPanel": {
    "checks": "Kontroller",
    "findAndFixConsistencyIssuesIn": "Din världs fakta, händelser och relationer jämförda med manuset. Ingen AI.",
    "running": "Kör…",
    "runChecks": "Kör kontroller",
    "lastRunAt": "Senast körd {{time}}",
    "oneAtATime": "En i taget",
    "exclusiveRelation": "Exklusiv relation",
    "noRelationIsExclusive": "Ingen relation är exklusiv",
    "exclusivityType": "Typ av exklusivitet",
    "oneSourcePerTarget": "En källa för varje mål",
    "oneTargetPerSource": "Ett mål för varje källa",
    "oneAtATimeHint": "En relation som bara kan gälla för en i taget, som ”äger”: två ägare av samma sak under samma tidpunkter blir en konflikt.",
    "rulesNeedRelations": "Reglerna använder dina relationer. Lägg till en under Kopplingar, som ”äger”, och gör den sedan exklusiv här.",
    "results": "Resultat",
    "whatTheChecksLookFor": "Vad kontrollerna letar efter",
    "twoHoldersAtOnce": "Två innehavare samtidigt",
    "eventsOutOfOrder": "Händelser i fel ordning",
    "quotedPastItsLimit": "Citerat efter sin gräns",
    "linksToDeletedEntries": "Länkar till borttagna poster",
    "notesThatLostTheirPlace": "Anteckningar som tappat sin plats",
    "relationsOverTime": "Relationer över tid",
    "scopeOwnership": "En sak som innehas av två poster under samma tidpunkter, utifrån bekräftade fakta.",
    "scopeFlashback": "En händelse som läses efter en som sker senare i världen: en tillbakablick eller ett misstag.",
    "scopeReveal": "Ett faktum som citeras i en scen efter den sista du tillät för det.",
    "scopeOrphans": "Anteckningar och fakta som pekar på en post eller ett bibliotekskort som inte längre finns.",
    "scopeAnchors": "Ett citerat stycke vars ord har flyttats eller ändrats i sin scen.",
    "scopeRelations": "Relationer mot regeln ovan och mot de citat de hänvisar till.",
    "filterResults": "Filtrera resultat",
    "all": "Alla",
    "conflicts": "Konflikter",
    "warnings": "Varningar",
    "needsData": "Behöver data",
    "noIssuesFound": "Inga problem hittades",
    "theExecutedRulesFoundNoViolation": "Ingenting bryter mot de fakta och regler du har angett. Kontrollerna känner bara till det du har registrerat.",
    "notEnoughData": "Inte tillräckligt med data",
    "quotesInTheText": "Citat i texten",
    "anchorInPlace": "På plats",
    "anchorMoved": "Flyttad",
    "anchorGone": "Borta",
    "reAnchor": "Förankra om",
    "openScene": "Öppna scen",
    "checkedAt": "Kontrollerad {{time}}.",
    "twoHold": "{{a}} och {{b}} innehar båda ”{{object}}” samtidigt.",
    "heldTwice": "{{a}} innehar ”{{object}}” två gånger under samma tidpunkter.",
    "flashbackSentence": "”{{earlier}}” sker före ”{{later}}” i världen men läses efter: en tillbakablick, om det inte är ett misstag.",
    "revealSentence": "”{{fact}}” citeras i {{scene}}, efter den sista scen du tillät för det.",
    "allowedUpToScene": "Tillåtet till och med scen {{scene}}",
    "orphanFactSentence": "Ett faktum (”{{fact}}”) handlar om en post som har tagits bort.",
    "orphanNoteSentence": "Anteckningen om ”{{excerpt}}” pekar på en borttagen post.",
    "orphanConceptSentence": "Anteckningen om ”{{excerpt}}” pekar på ett bibliotekskort som inte längre finns.",
    "movedSentence": "”{{excerpt}}” flyttades i {{scene}}: förankra om anteckningen så att den följer med.",
    "eventWithoutTime": "”{{title}}” har ingen tid i världen, så dess ordning kan inte kontrolleras.",
    "factWithoutTime": "”{{fact}}” har inget tidsintervall, så dess innehavare kan inte kontrolleras.",
    "recordWithoutTime": "En post har ingen tid, så den kan inte kontrolleras.",
    "aDeletedEntry": "en borttagen post",
    "aDeletedEvent": "en borttagen händelse",
    "aScene": "en scen",
    "fromTo": "Från {{start}} till {{end}}",
    "relativeToAnEvent": "Relativt en händelse",
    "timeNotSet": "Inte angiven",
    "facts": "Fakta",
    "factsLead": "Vad du anger om varje post. Kontrollerna läser de du bekräftar och jämför dem med manuset.",
    "entries": "Poster",
    "addAnEntry": "Lägg till en post",
    "addTheFirstEntry": "Lägg till den första posten",
    "newEntityName": "Ny entitets namn",
    "entityType": "Typ av entitet",
    "addEntity": "Lägg till entitet",
    "character": "Rollfigur",
    "place": "Plats",
    "object": "Föremål",
    "faction": "Fraktion",
    "other": "Övrigt",
    "deleteEntityReferencesBecomeOrphaned": "Ta bort entitet (referenser blir föräldralösa)",
    "deleteEntityName": "Ta bort entiteten {{name}}",
    "noFactYet": "Inget faktum om {{name}} ännu. Ett nytt faktum börjar som föreslaget; bekräfta det för att det ska räknas.",
    "proposed": "Föreslaget",
    "confirmed": "Bekräftat",
    "rejected": "Avvisat",
    "superseded": "Ersatt",
    "worldFact": "Faktum om världen",
    "characterBelief": "Övertygelse",
    "testimony": "Vittnesmål",
    "authorHypothesis": "Hypotes",
    "confirm": "Bekräfta",
    "confirmExplicitApproval": "Bekräfta (uttryckligt godkännande)",
    "newFactAbout": "Nytt faktum om {{name}}",
    "predicatePlaceholder": "äger",
    "predicate": "Predikat",
    "valuePlaceholder": "svärdet",
    "value": "Värde",
    "kind": "Typ",
    "epistemicKind": "Epistemisk typ",
    "kindHint": "Bara fakta om världen räknas som sanning; övertygelser, vittnesmål och hypoteser sparas men kontrolleras inte som kanon.",
    "when": "När",
    "timeKind": "Typ av tid",
    "betweenTwoMoments": "Mellan två tidpunkter",
    "from": "Från",
    "to": "till",
    "startTick": "Start-tick",
    "endTick": "Slut-tick",
    "momentsHint": "Tidpunkter på världens tidslinje; slutet ingår inte.",
    "reveal": "Avslöjande",
    "maximumRevealNarrativeIndex": "Maximalt avslöjande (berättelseindex)",
    "noLimit": "Ingen gräns",
    "sceneNumbered": "{{n}}. {{title}}",
    "revealHint": "Citat av det här faktumet i en senare scen flaggas.",
    "addFactProposed": "Lägg till som föreslaget",
    "selectAnEntityToSeeAnd": "Välj en post för att se och lägga till dess fakta.",
    "noEntityYet": "Ingen post ännu. Lägg till en rollfigur, en plats eller ett föremål ovan eller i Kodex.",
    "resultDetails": "Resultatets detaljer",
    "conflict": "Konflikt",
    "warning": "Varning",
    "whatWasCompared": "Vad som jämfördes",
    "whatToDo": "Vad du kan göra",
    "comparedOwnership": "Bekräftade fakta om världen med tidsintervall. Två innehavare av samma sak får inte överlappa.",
    "comparedFlashback": "Varje händelses tid i världen mot ordningen på dess scen i boken.",
    "comparedReveal": "Den sista scen du tillät för ett faktum mot de scener som citerar det.",
    "comparedOrphans": "Varje anteckning och varje faktum mot de poster och bibliotekskort som finns.",
    "comparedAnchors": "Varje antecknings citat mot scenens nuvarande text.",
    "confirmOnlyOneOwnerInThe": "Behåll en innehavare för de tidpunkterna: begränsa ett av tidsintervallen eller sätt ett faktum tillbaka till föreslaget.",
    "ifTheSceneIsADeliberate": "Om scenen är en avsiktlig tillbakablick, behåll den. Annars flytta scenen eller ändra händelsens tid.",
    "raiseTheMaximumRevealSceneOf": "Tillåt en senare scen för faktumet eller flytta citatet tidigare.",
    "restoreTheMissingEntityFromThe": "Återställ posten från Kodex-historiken eller ta bort anteckningen eller faktumet som pekar på den.",
    "useReAnchorManualOnThe": "Använd Förankra om på citatet i resultaten, eller öppna scenen och markera stycket igen.",
    "giveTheEventOrFactAn": "Ge den en tid i världen eller lämna den utan: kontrollen förblir tyst i stället för att gissa.",
    "selectAResult": "Välj ett resultat",
    "detailsConstraintsAndSuggestedFixesAppear": "Vad som jämfördes och vad du kan göra visas här.",
    "thisAnnotationCannotBeReAnchored": "Den här anteckningen kan inte förankras om: ”{{excerpt}}” saknas eller förekommer mer än en gång i scenen.",
    "revisionTools": "Granskningsverktyg",
    "loadingRevisionTools": "Läser in granskningsverktygen…"
  },
  "worldReplicationPanel": {
    "theContentChangedWhileItWas": "Innehållet ändrades medan det bekräftades. Välj det innehåll och det godkännande du granskade.",
    "theseChangesCannotBeCombinedInto": "De här ändringarna kan inte kombineras till en giltig Värld. Välj den fullständiga version som ska behållas; båda kopiorna finns kvar i återställningen.",
    "thisDevice": "Den här enheten",
    "yourAccount": "Ditt konto",
    "viewWorld": "Visa Världen",
    "previousSharedValue": "Tidigare delat värde",
    "theActionCouldNotFinishYour": "Åtgärden kunde inte slutföras. Dina lokala ändringar bevaras.",
    "worldSync": "Världens synkronisering",
    "syncCodexPagesFactsTimelinesCollections": "Synkronisera Kodex-sidor, fakta, tidslinjer, samlingar och bilagor mellan enheter. Anteckningar och skisser synkroniseras för sig, längre ned.",
    "syncWorldAutomatically": "Synkronisera Världen automatiskt",
    "n1PendingChange": "1 väntande ändring",
    "pendingPendingChanges": "{{pending}} väntande ändringar",
    "syncNow": "Synkronisera nu",
    "exportRecoveryCopies": "Exportera återställningskopior",
    "compareBeforeSyncing": "Jämför innan du synkroniserar",
    "signInToTheLinkedAccount": "Logga in på det kopplade kontot för att synkronisera. Lokala ändringar förblir sparade.",
    "signInToCompareYourWorld": "Logga in för att jämföra din Värld och aktivera synkronisering.",
    "chooseYourStartingWorld": "Välj din startvärld",
    "bothCopiesHaveTheSameContent": "Båda kopiorna har samma innehåll.",
    "keepTheWorldOnThisDevice": "Behåll Världen på den här enheten eller använd kopian på ditt konto. Den tidigare lokala Världen och bilagorna sparas i återställningen.",
    "keepThisDeviceSync": "Behåll den här enheten och synkronisera",
    "useAccountCopySync": "Använd kontokopian och synkronisera",
    "cancel": "Avbryt",
    "reviewConcurrentChanges": "Granska samtidiga ändringar",
    "chooseEachValueToKeepOther": "Välj varje värde som ska behållas. Övriga ändringar slås ihop automatiskt. Båda versionerna går att återställa.",
    "applyReviewedChoices": "Tillämpa de granskade valen",
    "syncingWorldAndAttachments": "Synkroniserar Världen och bilagorna…",
    "codexPages": "Kodex-sidor",
    "onThisDevice": "På den här enheten",
    "waitingToSync": "Väntar på synkronisering",
    "syncing": "Synkroniserar…",
    "upToDate": "Uppdaterad",
    "reviewNeeded": "Kräver granskning",
    "emptyText": "(tom text)",
    "emptyList": "(tom lista)",
    "worldStructure": "Världens struktur",
    "labelFacts": "Fakta",
    "labelEvents": "Händelser",
    "labelKnowledge": "Kunskap",
    "labelAnnotations": "Anteckningar",
    "labelRelationships": "Relationer",
    "labelAttachments": "Bilagor",
    "labelCollections": "Samlingar",
    "labelFolders": "Mappar",
    "paused": "Pausad",
    "addedCount_one": "{{count}} tillagd",
    "addedCount_other": "{{count}} tillagda",
    "removedCount_one": "{{count}} borttagen",
    "removedCount_other": "{{count}} borttagna",
    "changedCount_one": "{{count}} ändrad",
    "changedCount_other": "{{count}} ändrade",
    "removedValue": "Borttagen",
    "emptyValue": "Tom"
  },
  "worldReviewTools": {
    "deletedEntry": "Borttagen post",
    "timeUnknown": "Okänd tid",
    "storyTimeInterval": "Intervall i berättelsens tid",
    "relativeToEventPreserved": "Relativt en händelse (bevarat)",
    "from": "Från",
    "until": "Till",
    "characterKnowledge": "Rollfigurernas kunskap",
    "couldNotCheckTheSavedManuscriptRetry": "Det gick inte att kontrollera det sparade manuset. Försök igen.",
    "revisionTools": "Granskningsverktyg",
    "changeImpact": "Ändringars påverkan",
    "whatPointsToThisRecord": "Vad pekar på den här posten?",
    "explicitLinksOnlyIncludingIndirectLinksChangingARecord": "Endast uttryckliga länkar, inklusive indirekta länkar. Att ändra en post skriver inte om det som beror på den.",
    "impactRecord": "Påverkad post",
    "chooseARecord": "Välj en post",
    "linkedRecordsWorldRevision": "länkade poster · Världens revision",
    "directLink": "Direkt länk",
    "missingSourceScene": "Källscen saknas",
    "noExplicitRecordLinksToThisEntryUnlinkedProse": "Inga uttryckliga postlänkar till den här posten. Olänkad prosa ligger utanför den här kontrollen.",
    "whenDidTheyLearnIt": "När fick de veta det?",
    "recordAcquisitionAndUseOnTheSameStoryTime": "Registrera när kunskapen förvärvades och användes på samma axel för berättelsens tid. Gissningar och övertygelser hålls åtskilda; kapitelordningen behandlas aldrig som berättelsens tid.",
    "recordKnowledge": "Registrera kunskap",
    "couldNotSaveCheckTheIntervalsOrCancelAnd": "Det gick inte att spara. Kontrollera intervallen eller avbryt och öppna igen om Världen ändrades.",
    "character": "Rollfigur",
    "knowledgeCharacter": "Rollfigur som vet",
    "chooseACharacter": "Välj en rollfigur",
    "fact": "Faktum",
    "knowledgeFact": "Känt faktum",
    "chooseAConfirmedWorldFact": "Välj ett bekräftat faktum om världen",
    "acquired": "Förvärvad",
    "acquisitionSource": "Källa för förvärvet",
    "noSourceAttached": "Ingen källa bifogad",
    "use": "Användning",
    "scene": "Scen",
    "chooseAScene": "Välj en scen",
    "knownInformation": "Känd information",
    "belief": "Övertygelse",
    "guess": "Gissning",
    "passageSource": "Källa för stycket",
    "noPassageAttached": "Inget stycke bifogat",
    "removeUse": "Ta bort användningen",
    "addUse": "Lägg till användning",
    "confirmAndSave": "Bekräfta och spara",
    "cancel": "Avbryt",
    "missingFact": "Saknat faktum",
    "atUnknownRelativeTime": "vid okänd/relativ tid",
    "edit": "Redigera",
    "couldNotRemoveTheRecordRefreshAndRetry": "Det gick inte att ta bort posten. Uppdatera och försök igen.",
    "checkSavedKnowledge": "Kontrollera sparad kunskap",
    "theWorldChangedSinceThisResultRunTheCheck": "Världen har ändrats sedan det här resultatet. Kör kontrollen igen.",
    "recordedUseIsEarlierThanAcquisition": "Registrerad användning ligger före förvärvet",
    "recordedTimesAreInOrder": "Registrerade tider är i ordning",
    "beliefOrGuessNotAKnowledgeConflict": "Övertygelse eller gissning – ingen kunskapskonflikt",
    "notEnoughInformationToCompare": "Inte tillräckligt med information för att jämföra",
    "attachedPassagesMatchTheSavedText": "Bifogade stycken stämmer med den sparade texten",
    "aSourceIsMissingStaleOrBelongsToAnother": "En källa saknas, är föråldrad eller tillhör en annan scen",
    "authorRecordedTimesPassagesAreNotVerified": "Tider som författaren registrerat; styckena verifieras inte",
    "openScene": "Öppna scen",
    "noConfirmedKnowledgeUsesToCompare": "Inga bekräftade kunskapsanvändningar att jämföra.",
    "openNamedScene": "Öppna {{title}}",
    "recordSummary": "Användningar: {{count}} · {{lifecycle}} · Förvärvad {{time}}",
    "checkSummary": "Kontrollerad {{time}} · {{count}} registrerade användningar. Uppdatera efter att du redigerat prosan.",
    "resultsLimitedTo500Records": "Resultaten begränsade till 500 poster",
    "linksAway": "{{depth}} länkar bort",
    "useNKind": "Användning {{n}}: typ",
    "useN": "Användning {{n}}",
    "useNSource": "Användning {{n}}: källa",
    "checking": "Kontrollerar …"
  },
  "worldSection": {
    "overview": "Översikt",
    "vault": "Valv",
    "timeline": "Tidslinje",
    "connections": "Kopplingar",
    "references": "Referenser",
    "checks": "Kontroller",
    "analysis": "Analys",
    "characters": "Rollfigurer",
    "locations": "Platser",
    "factions": "Fraktioner",
    "objects": "Föremål",
    "concepts": "Begrepp",
    "worldViews": "Världsvyer",
    "world": "Värld",
    "browseByType": "Bläddra efter typ",
    "filterByType": "Filtrera efter typ",
    "all": "Alla",
    "newEntry": "Ny post",
    "cercaNelCodex": "Sök i Kodex",
    "searchEntries": "Sök poster…",
    "entry": "post",
    "entries": "poster",
    "alsoAliases": "Även: {{aliases}}",
    "noEntriesYetCreateTheFirst": "Inga poster ännu. Skapa den första rollfiguren, platsen eller fraktionen.",
    "noEntryMatches": "Ingen post matchar.",
    "editName": "Redigera {{name}}",
    "edit": "Redigera",
    "archive": "Arkivera",
    "confirmArchive": "Bekräfta arkivering",
    "notesAndSketches": "Anteckningar och skisser",
    "alsoKnownAs": "Även känd som",
    "addADescriptionOneLineThat": "Lägg till en beskrivning – en rad som säger vad det här är.",
    "none": "Ingen",
    "yes": "Ja",
    "no": "Nej",
    "removedEntry": "Borttagen post",
    "unavailableEntry": "Otillgänglig post",
    "noNotesYetEditTheEntry": "Inga anteckningar ännu. Redigera posten för att beskriva den.",
    "linkedScenes": "Länkade scener",
    "showTheEntriesOfABook": "Visa posterna i en bok",
    "allBooks": "Alla böcker",
    "bookLine": "Bok {{number}} · {{title}}",
    "inNoBookYet": "Ännu i ingen bok",
    "scenesThatMentionThisEntryBy": "Scener som nämner den här posten med namn eller alias visas här.",
    "facts": "Fakta",
    "noFactRecordedFactsAreAdded": "Inga fakta registrerade. Fakta läggs till och godkänns i Kontroller.",
    "relations": "Relationer",
    "noRelationYet": "Ingen relation ännu.",
    "proposed": " · föreslagen",
    "viewAll": "Visa alla",
    "attachments": "Bilagor",
    "attachAnImageToUseIt": "Bifoga en bild för att använda den som porträtt.",
    "kib": "KiB",
    "open": "Öppna",
    "remove": "Ta bort",
    "addAttachment": "Lägg till bilaga",
    "stateAtStoryTime": "Tillstånd vid en viss tid i berättelsen",
    "tick": "Tick",
    "factsWithoutACompleteInterval": "fakta utan fullständigt intervall.",
    "selectAnEntry": "Välj en post",
    "charactersPlacesFactionsAndObjectsLive": "Här finns rollfigurer, platser, fraktioner och föremål, med sina fakta, relationer och bilagor.",
    "recentChanges": "Senaste ändringar",
    "undoChange": "Ångra ändringen",
    "worldTimeline": "Världens tidslinje",
    "eventsPeopleAndPlacesInA": "Händelser, människor och platser i ett större sammanhang.",
    "noEventYet": "Ingen händelse ännu",
    "addTheFirstEventWithA": "Lägg till den första händelsen med en tid i berättelsen, eller lämna tiden okänd tills du vet den.",
    "tick2": "tick",
    "plotEvent": "Intrighändelse",
    "worldEvent": "Världshändelse",
    "openScene": "Öppna scen",
    "unknownTime": "Okänd tid",
    "unknown": "okänd",
    "seeHowYourWorldSPeople": "Se hur människorna, platserna och idéerna i din värld hänger ihop.",
    "connectionsView": "Vy för kopplingar",
    "graph": "Graf",
    "list": "Lista",
    "nothingToConnectYet": "Inget att koppla ännu",
    "createEntriesInTheCodexAnd": "Skapa poster i Kodex och relatera dem i listvyn.",
    "selectedEntry": "Vald post",
    "relationSummary": "Sammanfattning av relationer",
    "noSceneMentionsThisEntryYet": "Ingen scen nämner den här posten ännu.",
    "openInCodex": "Öppna i Kodex",
    "selectANodeToSeeIts": "Välj en nod för att se dess relationer och scener.",
    "annotationsAnchoredInTheManuscriptAnd": "Kommentarer förankrade i manuset och de filer du förvarar för din värld.",
    "addFile": "Lägg till fil",
    "annotations": "Kommentarer",
    "selectTextInTheManuscriptAnd": "Markera text i manuset och välj ”Kommentera” för att förankra ett berättargrepp, en entitet eller en anteckning.",
    "scene": "Scen",
    "device": "Berättargrepp",
    "entity": "Entitet",
    "note": "Anteckning",
    "imagesPdfsNotesAndAudioYou": "Bilder, PDF-filer, anteckningar och ljud som du bifogar världen eller en post.",
    "linked": "Länkad",
    "orphan": "Föräldralös",
    "openFile": "Öppna fil",
    "referenceDetails": "Referensens detaljer",
    "textAnnotation": "Textkommentar",
    "kind": "Typ",
    "anchor": "Förankring",
    "concept": "Begrepp",
    "created": "Skapad",
    "anchorStatesValidStaleOrphanedAnd": "Förankringens tillstånd (giltig, föråldrad, föräldralös) och omförankring beräknas i Kontroller.",
    "attachment": "Bilaga",
    "type": "Typ",
    "size": "Storlek",
    "linkedTo": "Länkad till",
    "added": "Tillagd",
    "confirmRemove": "Bekräfta borttagning",
    "selectAnAnnotationOrAFile": "Välj en kommentar eller en fil.",
    "exploreTheShapeOfYourStory": "Utforska formen på din berättelse: längd, närvaro och täthet över scenerna.",
    "sceneLength": "Scenlängd",
    "wordsPerScene": "Ord per scen",
    "noScenesYet": "Inga scener ännu.",
    "titleFmtWords": "{{title}}: {{fmt}} ord",
    "entityDensity": "Entitetstäthet",
    "codexMentionsPerScene": "Kodex-omnämnanden per scen",
    "titleMentionsMentions": "{{title}}: {{mentions}} omnämnanden",
    "characterAppearanceMap": "Karta över rollfigurernas framträdanden",
    "aDotWhereACharacterIs": "En prick där en rollfigur nämns i en scen",
    "addCharactersToTheCodexAnd": "Lägg till rollfigurer i Kodex och nämn dem i scenerna.",
    "thisScene": "Den här scenen",
    "words": "Ord",
    "paragraphs": "Stycken",
    "sentencesEst": "Meningar (uppsk.)",
    "distinctWords": "Olika ord",
    "annotatedDevices": "Kommenterade berättargrepp",
    "n1000Words": "/ 1 000 ord",
    "repetitions": "Upprepningar",
    "exportHtml": "Exportera HTML",
    "exportTxt": "Exportera TXT",
    "events": "Händelser",
    "confirmedFacts": "Bekräftade fakta",
    "recentlyChanged": "Nyligen ändrat",
    "changesToTheWorldWillBe": "Ändringar i världen listas här, var och en med en ångra-knapp.",
    "undo": "Ångra",
    "startHere": "Börja här",
    "overviewEmptyLead": "Människorna, platserna och händelserna i din berättelse, länkade till de scener där de förekommer.",
    "addACharacter": "Lägg till en rollfigur",
    "addACharacterText": "Vem de är, vad de vill och vad som står i vägen.",
    "addAPlace": "Lägg till en plats",
    "addAPlaceText": "Där scener utspelar sig: en stad, ett skepp, ett enda rum.",
    "addAnEventText": "Något som händer i berättelsen, med sitt datum eller utan.",
    "inThisWorld": "I den här världen",
    "createAnEntry": "Skapa en post",
    "aCharacterAPlaceAFaction": "En rollfigur, en plats, en fraktion, ett föremål eller ett begrepp.",
    "addAnEvent": "Lägg till en händelse",
    "withAnExactStoryTimeOr": "Med en exakt tid i berättelsen eller en okänd.",
    "runTheChecks": "Kör kontrollerna",
    "deterministicRulesOwnershipOrderAnchorsOrphans": "Ägare, ordning, avslöjanden och relationer över tid, jämförda med texten.",
    "loadingTheWorld": "Läser in världen…",
    "maps": "Kartor",
    "openItsMap": "Öppna dess karta",
    "addAMap": "Lägg till en karta",
    "pinnedOn": "Fäst på",
    "typeCharacter": "Karaktär",
    "typeLocation": "Plats",
    "typeObject": "Föremål",
    "typeFaction": "Fraktion",
    "typeConcept": "Koncept",
    "annotationsToReAnchor_one": "{{count}} anteckning att förankra på nytt.",
    "annotationsToReAnchor_other": "{{count}} anteckningar att förankra på nytt."
  }
}
